import account from '@/store/account/index.js'
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    account
  }
})

store.subscribe((mutation, state) => {
  if (mutation.type === 'account/init') return
  localStorage.setItem('state', JSON.stringify(state))
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js